(function ($, Drupal) {
  Drupal.behaviors.blockGallery = {
    attach: function (context) {
      once('blockGallery', '.block--gallery', context).forEach(function (element) {
        const target = element.querySelector('.swiper');
        window.addEventListener('resize', function () {
          // eslint-disable-next-line no-unused-vars
          const gallerySwiper = new Swiper(target, {
            cssMode: true,
            slidesPerView: 'auto',
            spaceBetween: 24,
            navigation: {
              prevEl: element.querySelector('.swiper-control-prev'),
              nextEl: element.querySelector('.swiper-control-next'),
            },
            breakpoints: {
              768: {
                spaceBetween: 40,
              },
            },
          });
        });

        // Trigger resize event to handle slider state
        window.dispatchEvent(new Event('resize'));
      });
    },
  };
}(jQuery, Drupal));
